import React from 'react';
import styled from 'styled-components';
import PropTypes from 'prop-types';

const BannerDiv = styled.div`
  background: #5a5a5a;
  padding: 10px;
  max-height: 100%;
`;

const PageBanner = (props) => (
  <BannerDiv>
    <span style={{ color: '#FFFFFF', display: 'flex', justifyContent: 'center', flexWrap: 'wrap', alignItems: 'center' }}>
      {props?.acpBannerContent}
    </span>
  </BannerDiv>
);

PageBanner.propTypes = {
  acpBannerContent: PropTypes.string,
};

export default PageBanner;
